import { fork, put, takeEvery, all } from "redux-saga/effects";

import { push } from "react-router-redux";

import { actions } from "./index";

const to = function*({ payload: url }) {
  yield put(push(url));
};

const watchTo = function*() {
  yield takeEvery(actions.to.type, to);
};

const rootSaga = function*() {
  yield all([fork(watchTo)]);
};

export default rootSaga;
